import React from 'react';
import { Search } from 'lucide-react';

const SearchBar: React.FC = () => {
  return (
    <div className="relative w-full max-w-md mx-auto">
      <input
        type="text"
        placeholder="Search something here..."
        className="w-full pl-12 pr-4 py-2 rounded-full bg-gray-200 focus:outline-none text-sm"
      />
      <Search
        size={26}
        className=" bg-primary/10 p-1 rounded-full absolute left-4 top-1/2 -translate-y-1/2 text-black"
      />
    </div>
  );
};

export default SearchBar;